import { useSuspenseQuery } from '@tanstack/react-query'

import { paymentProfileQueryOptions } from '@/queries/profile'
import { PaymentProfileResponse, walletAccountTypeMap } from '@/types/profile'

export const selectMappedPaymentProfile = (data: PaymentProfileResponse) => {
  return {
    ...data,
    accountTypeDisplay: walletAccountTypeMap[data.wallet?.account_type],
  }
}

export const useMappedPaymentProfile = () => {
  return useSuspenseQuery({
    ...paymentProfileQueryOptions,
    select: selectMappedPaymentProfile,
  })
}
